import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AllReportsErpComponent } from './all-reports-erp/all-reports-erp.component';
import { ReportsRoutingErpModule } from './reports.routing.module';
import { HttpClientModule } from '@angular/common/http';




@NgModule({
  declarations: [AllReportsErpComponent],
  imports: [
    CommonModule,
    ReportsRoutingErpModule,
    HttpClientModule
  ], 
  exports: [AllReportsErpComponent]
})
export class ReportsErpModule { }
